module.exports = __webpack_public_path__ + "static/yellow-card-04b208b772b85f3d2ed27d7c451f9f8b.svg";